import React, { useState } from "react";
import { Table } from "../../../components";
import { SearchBlack } from "../../../components/Icons/Icons";
import classNames from "classnames/bind";
import styles from "./Assignment.module.css";

const cx = classNames.bind(styles);
const Assignment = () => {
  const [departments, setDepartments] = useState([
    {
      name: "Phòng hậu cần",
      number_camera: 4,
      number_staff: 4,
    },
  ]);
  const colum = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: "Tên phòng ban",
      key: "name",
    },
    {
      label: "Số lượng camera",
      key: "number_camera",
    },
    {
      label: "Số lượng nhân viên",
      key: "number_staff",
    },
    {
      label: "Hành động",
      key: "action",
    },
  ];
  const data = departments.map((item, index) => {
    return {
      stt: index + 1,
      name: item.name,
      number_camera: item.number_camera,
      number_staff: item.number_staff,
      action: <div></div>,
    };
  });
  return (
    <div>
      <div className={cx("container")}>
        <div className={cx("header")}>
          <h1 className={cx("title")}>Khoanh vùng đối tượng</h1>
        </div>
        <div className={cx("filter")}>
          <div className={cx("search")}>
            <input
              className={cx("search-input")}
            //   value={dataInput}
            //   onChange={onChangeTextSearch}
              placeholder="Tìm kiếm..."
            />
            <span className={cx("icon-search")}>
              <SearchBlack />
            </span>
          </div>
        </div>
        <Table colum={colum} data={data} />
      </div>
    </div>
  );
};

export default Assignment;
